class ProductDeliveryCountdown extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.deliveryEndTime = Date.now() + 1000 * 6 * 60 * 60;
    this.updateDeliveryTimer();

    var deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + 3);
    var formattedDate = deliveryDate.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });

    this.querySelectorAll('.daycount').forEach(function (element) {
      element.innerText = formattedDate;
    });
  }

  disconnectedCallback() {
    window.clearTimeout(this.deliveryTimer);
    delete this.dataset.ready;
  }

  twoDigits(number) {
    return number <= 9 ? '0' + number : number;
  }

  updateDeliveryTimer() {
    var millisecondsLeft = this.deliveryEndTime - Date.now();
    if (millisecondsLeft < 1000) {
      this.style.display = 'none';
      return;
    }

    var time = new Date(millisecondsLeft);
    var hours = time.getUTCHours();
    var minutesLeft = time.getUTCMinutes();
    var timeString =
      (hours ? hours + 'h ' + this.twoDigits(minutesLeft) : minutesLeft) +
      'm ' +
      this.twoDigits(time.getUTCSeconds()) +
      's';

    this.querySelectorAll('.countdown').forEach(function (element) {
      element.innerHTML = timeString;
    });
    this.deliveryTimer = window.setTimeout(this.updateDeliveryTimer.bind(this), 1000);
  }
}

if (!customElements.get('product-delivery-countdown')) {
  customElements.define('product-delivery-countdown', ProductDeliveryCountdown);
}
